import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#747476",
            d: "M12.833 9.92c-.333 0-.605.27-.605.605v6.333h-1.791V8.274c-.001-.333-.27-.602-.604-.603-.334 0-.604.27-.604.603v8.584H7.437v-6.333c-.001-.334-.27-.603-.604-.604-.334 0-.604.27-.604.604v6.333H4.812V5.317h10.042v11.54h-1.416v-6.332c0-.334-.272-.604-.605-.604m-2.812-7.042c.99.001 1.839.355 2.279 1.228H7.74c.44-.876 1.29-1.227 2.28-1.228m6.75 1.228h-3.19c-.57-1.469-1.98-2.44-3.56-2.44-1.577 0-2.99.971-3.558 2.44H3.27c-.333 0-.603.271-.603.606 0 .332.27.604.603.604h.334v11.582c0 .644.523 1.167 1.166 1.167h10.126c.643 0 1.166-.523 1.166-1.167V5.317h.709c.333 0 .603-.272.603-.604 0-.335-.27-.606-.603-.606",
            transform: "translate(-113 -108) translate(113 108)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }